import { Component } from '@angular/core';

@Component({
  moduleId: String(module.id),
  selector: 'kui-accordion',
  templateUrl: './accordion.component.html',
})
export class KuiAccordionComponent { }
